<template>
  <modal-form
    :class="$style.dialog"
    @cancel="$formCancelHandler"
    @submit="$formSubmitHandler"
  >
    <div
      slot="header"
      :class="$style.header"
    >
      <i class="material-icons">info_outline</i>
      <div>
        <div :class="$style.title">
          New User Created
        </div>
        <div :class="$style.subTitle">
          {{ name }}
        </div>
      </div>
    </div>
    <div
      slot="body"
      class="vModalDefaultBody"
      :class="$style.body"
    >
      New user <b>{{ name }}</b> was created successfully and given {{ role }} privileges.
      Would you like to send them an invitation so they can complete registration.
    </div>

    <div
      slot="footer"
      class="vModalDefaultFooter"
    >
      <button
        class="rbButton"
        type="button"
        @click="cancel()"
      >
        No, Thank You
      </button>
      <button
        class="rbButton mainButton"
      >
        Yes, Please Send
      </button>
    </div>
  </modal-form>
</template>

<script>

  import ModalForm from 'vRoot/_core/RbModalForm.vue'
  import DialogMixin from 'vRoot/_mixins/DialogMixin.vue'
  import RbFormMixin from 'root/v-components/_mixins/RbFormMixin.vue'

  export default {
    name: 'UserCreatedDialog',
    components: { ModalForm },
    mixins: [ RbFormMixin, DialogMixin ],
    props: {
      id: {
        type: String,
        default: ''
      },
      name: {
        type: String,
        default: ''
      },
      role: {
        type: String,
        default: 'Account Manager'
      }
    },
    methods: {
      onSubmit(){
        return {};
      }
    }
  }
</script>

<style lang="stylus" module>

  .dialog {
    width: 450px;
    overflow visible
  }

  .body{
    line-height: 2;
    font-size: 12px;
    color: #637b85;
  }

  .header{
    display flex;
    align-items center;
  }

  .header i{
    font-size 45px;
    color #00b4a6;
    margin-right: 10px;
  }

  .header > .title{
    font-size 15px;
  }

  .header .subTitle{
    font-size 17px;
    font-weight: normal;
  }
</style>
